const config = {
    common: {
        protocol: 'http',
        server: 'localhost:8084',
        apiPath: '/connect/api',
        contentsPath: '/connect/photos/',
        photoPath: '/connect/photo_files/',
    }
}

export default config